module.exports = __webpack_public_path__ + "img/peitu.1798d18f.svg";